let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1AKjA")).then(() => parcelRequire('8BA4O'));